<template>
    <div class="societiesCarouselMobile">
        <Carousel :items-to-show="1.2">
            <Slide v-for="(slide, index) in data[0]" :key="index">
            <!-- <Slide v-for="(slide, index) in data[0].concat(data[1])" :key="index"> -->
                <societySlideMobile :slide="slide" />
            </Slide>

            <template #addons>
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>

<script src="./script.js"></script>
